import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { AuthHttp } from "angular2-jwt/angular2-jwt";
import { SessionStorageService } from "ngx-webstorage/dist/services";
import { ConstantService } from "../../../components/common/utils/constant.service";
import { ClienteLogin, Cliente, ClienteXCiudad } from "../../login/cliente_login";
import { Headers, Http, Response, RequestOptions, ResponseContentType } from '@angular/http';
import { PolizaEntity } from "../entities/polizas_cliente_entity";
import { EquipoExclusionEntity, CabeceraEquipoExclusionEntity } from "../entities/equipos_exclusion_entity";

declare var jQuery: any;

@Injectable()
export class ExclusionEquiposService {
    sesionStorageService: any;
    private url = "solicitudes";


    constructor(private authHttp: AuthHttp, private sessionStorageService: SessionStorageService) {
        let constantService = new ConstantService();
        this.url = constantService.API_ENDPOINT + this.url;
    }

    consultaEquipos(poliza: PolizaEntity): Observable<any> {                
        let body = JSON.stringify(poliza);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/consultaEquiposAExcluir", body, options).map(this.extractData)
            .catch(this.handleError);
    }

    excluirEquipos(equipos: CabeceraEquipoExclusionEntity): Observable<any> {                
        let body = JSON.stringify(equipos);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/excluirEquipos", body, options).map(this.extractData)
            .catch(this.handleError);
    }    

    private extractData(res: Response) {
        let body = res.json();
        return body || {};
    }
    private handleError(error: any) {
        return Observable.throw(error);
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/solicitudes/solicitud-equipo.service.ts